<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-md-12">
          <h3 class="page-title">Change Password</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="submit">
      <div class="form-group">
        <label>Current Password<span class="text-danger">*</span></label>
        <input
          class="form-control"
          required
          type="password"
          v-model="currentPassword"
          maxlength="50"
          autocomplete="off"
        />
      </div>
      <div class="alert alert-info text-justify">
        Password Requirement: Must be minimum of 6 characters with combination
        of upper and lower case letters, numbers, and non-alphanumeric symbols
      </div>
      <div class="form-group">
        <label>New Password<span class="text-danger">*</span></label>
        <input
          class="form-control"
          required
          type="password"
          v-model="newPassword"
          maxlength="50"
          autocomplete="off"
        />
      </div>
      <div class="form-group">
        <label>Confirm New Password<span class="text-danger">*</span></label>
        <input
          class="form-control"
          required
          type="password"
          v-model="confirmNewPassword"
          maxlength="50"
          autocomplete="off"
        />
      </div>
      <div class="form-group row mt-4">
        <div class="col">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <i class="fa fa-reply mr-2"></i>Back
          </button>
        </div>
        <div class="col-auto float-right ml-auto">
          <button type="submit" class="btn btn-primary">Save Changes</button>
        </div>
      </div>
    </form>
    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
    userId() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Id;
    },
  },
  methods: {
    submit() {
      if (this.newPassword !== this.confirmNewPassword) {
        this.$swal("New Password and Confirm New Password do not match", {
          icon: "error",
        });
        return;
      }
      let param = {
        Token: this.token,
        Id: this.userId,
        CurrentPassword: this.currentPassword,
        NewPassword: this.newPassword,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to change your password?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSubmit) => {
        if (willSubmit) {
          this.$store.state.isLoading = true;
          API.mainAdmin
            .changePassword(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.currentPassword = "";
                this.newPassword = "";
                this.confirmNewPassword = "";
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/MainAdmin/ChangePassword.vue